import Vue from 'vue';
export default Vue.extend({
    name: 'Tooltip',
    props: {
        delay: { type: Number },
        position: { type: String, default: 'bottom' },
        tooltipProps: {
            type: Object,
            default: () => ({ qTooltipProps: {} })
        }
    },
    computed: {
        computedProps() {
            const positionMap = {
                top: { anchor: 'top middle', self: 'bottom middle' },
                right: { anchor: 'center right', self: 'center left' },
                bottom: { anchor: 'bottom middle', self: 'top middle' },
                left: { anchor: 'center left', self: 'center right' }
            };
            return Object.assign(Object.assign(Object.assign({}, positionMap[this.position]), this.tooltipProps.qTooltipProps), { delay: this.delay });
        }
    }
});
